// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6230ae13","239":"b1b4bc65","455":"5b6f2c7c","488":"457b802d"}[chunkId] + ".chunk.js";
};